import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.SynergyView.heading',
    defaultMessage: 'Synergia grupy kapitałowej'
  }
});



// WEBPACK FOOTER //
// ./src/views/Synergy/SynergyView.intl.js